import React from 'react';

export default class Loader extends React.Component {

    static defaultProps = {
        fillContainer: false,
        fillBackground: 'rgba(245, 245, 245, 0.5)',
        showBalls: true
    }

    render() {
        let styles = {};

        if (this.props.fillContainer) {
            styles = {
                position: 'absolute',
                width: '100%',
                height: '100%',
                background: this.props.fillBackground,
                zIndex: 1001,
                top: 0,
                left: 0
            }
        }

        return (
            <div style={styles}>
                <div className="ball-loader visible" style={{backgroundColor: 'transparent'}}>
                    {this.props.showBalls && (
                        <React.Fragment>
                            <div className="ball-loader-ball1"></div>
                            <div className="ball-loader-ball2"></div>
                            <div className="ball-loader-ball3"></div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        )
    }
}